export enum LegalDocumentType {
    PrivacyPolicy = 'privacy-policy',
    TermsOfService = 'terms-of-service',
    BuyersTermsOfService = 'buyers-terms-of-service',
}
